<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h6 primary white--text"> Migração </v-card-title>
        <v-col class="pt-0 pb-0" cols="12">
          <v-checkbox v-model="check" label="Transferir aluno" :value="check"></v-checkbox>
        </v-col>
        <v-select
          v-if="check"
          class="px-3 my-5"
          :items="franquias"
          item-text="descricao"
          item-value="id"
          :hint="`${franquiaSelecionada.descricao}`"
          return-object
          @change="(event) => listarTurmasFranquiaSelect(event)"
          label="Selecione uma escola"
          v-model="franquiaSelecionada"
        >
        </v-select>
        <v-select
          v-if="check"
          class="px-3 my-5"
          :items="turmas"
          item-text="descricao"
          item-value="id"
          :hint="`${turmaSelecionada.descricao}`"
          return-object
          label="Selecione uma turma"
          v-model="turmaSelecionada"
        >
        </v-select>
        <v-select
          v-if="!check"
          class="px-3 my-5"
          :items="$constants.situacoesMatricula"
          label="Selecione uma situação"
          v-model="matricula.situacao"
        >
        </v-select>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="$emit('dialogChange', false)"> Fechar </v-btn>
          <v-btn color="primary" @click="enableSubmit" text> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="confirmDialog = false"
      @changeActionResponse="transferirMatricula"
    >
    </e-modal-confirm>

    <!-- Modal de Alerta BNCC -->
    <v-dialog v-model="bnccWarningDialog" persistent width="500">
      <v-card class="bncc-warning-modal">
        <v-card-title class="text-h5 primary white--text py-4">
          <v-icon large left class="mr-2" color="white">mdi-alert</v-icon>
          Sistemas BNCC Divergentes
        </v-card-title>
        <v-card-text class="pa-6">
          <div class="warning-content">
            <v-alert type="warning" prominent class="mb-4 secondary white--text">
              <div class="d-flex align-center">
                <strong>Atenção! Sistemas BNCC diferentes detectados</strong>
              </div>
            </v-alert>

            <div class="warning-details">
              <div class="info-item mb-3">
                <v-icon small color="grey darken-1" class="mr-2 mb-5">mdi-information</v-icon>
                <span class="text-body-2 grey--text text--darken-2">
                  Turma de destino utiliza sistema BNCC diferente da matricula atual.
                </span>
              </div>

              <v-divider class="my-3"></v-divider>

              <div class="consequences">
                <div class="consequence-item d-flex align-start mb-2">
                  <v-icon small color="error" class="mr-2">mdi-close-circle</v-icon>
                  <span class="text-body-2">
                    <strong>Lançamentos não serão transferidos:</strong>
                  </span>
                </div>
                <div class="consequence-list ml-6">
                  <div class="d-flex align-center mb-1">
                    <v-icon x-small class="mr-2">mdi-circle</v-icon>
                    <span class="text-caption">Relatório de Ensino Infantil</span>
                  </div>
                  <div class="d-flex align-center mb-1">
                    <v-icon x-small class="mr-2">mdi-circle</v-icon>
                    <span class="text-caption"
                      >Relatório de Descritivo de Desenvolvimento Ensino Infantil</span
                    >
                  </div>
                  <div class="d-flex align-center mb-1">
                    <v-icon x-small class="mr-2">mdi-circle</v-icon>
                    <span class="text-caption">Faltas e frequências</span>
                  </div>
                  <div class="d-flex align-center">
                    <v-icon x-small class="mr-2">mdi-circle</v-icon>
                    <span class="text-caption">Outros registros acadêmicos</span>
                  </div>
                </div>
              </div>

              <v-divider class="my-4"></v-divider>

              <div class="confirmation-text text-center">
                <p class="text-body-1 font-weight-medium mb-0">
                  Deseja continuar com a transferência mesmo assim?
                </p>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="bnccWarningDialog = false" class="px-4" large>
            <v-icon left>mdi-cancel</v-icon>
            Não, cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="prosseguirComTransferencia"
            class="px-4 white--text"
            large
            depressed
          >
            <v-icon left>mdi-check</v-icon>
            Sim, continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    matricula: {
      type: Object,
      required: true,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      check: false,
      turmas: [],
      franquias: [],
      turmaSelecionada: {},
      franquiaSelecionada: {},
      situacaoSelecionada: "",
      confirmDialog: false,
      bnccWarningDialog: false,
      objectModal: {
        title: "Migração",
        message: "Tem certeza que deseja executar está ação ?",
      },
    };
  },
  watch: {
    dialog: {
      async handler() {
        this.franquias = await this.$services.franquiasService.listAllSelect();
      },
    },
  },
  methods: {
    enableSubmit() {
      if (this.check && (!this.turmaSelecionada.id || !this.franquiaSelecionada.id)) {
        this.$toast.danger("Preencha os campos Escola e Turma.");
        return;
      }

      if (!this.check) {
        this.confirmDialog = true;
        return;
      }

      const isOrigemInfantil = this.matricula.curso_id === 1;
      const isDestinoInfantil = this.turmaSelecionada.isInfantil;

      if (
        isOrigemInfantil &&
        isDestinoInfantil &&
        this.matricula.sistema_bncc_id &&
        this.turmaSelecionada.sistema_bncc_id &&
        this.matricula.sistema_bncc_id !== this.turmaSelecionada.sistema_bncc_id
      ) {
        this.bnccWarningDialog = true;
      } else {
        this.confirmDialog = true;
      }
    },

    prosseguirComTransferencia() {
      this.bnccWarningDialog = false;
      this.confirmDialog = true;
    },
    async listarTurmasFranquiaSelect(franquia) {
      const form = {
        franquia,
        matricula: this.matricula,
      };
      this.turmas = await this.$services.turmasService.listarTurmasFranquiaSelect(form);
      this.turmas = this.turmas.filter((turma) => turma.id !== this.matricula.turma_id);
    },
    async transferirMatricula() {
      this.$emit("changeDialog");
      this.confirmDialog = !this.confirmDialog;

      try {
        const form = {
          matriculaTransferida: {
            aluno_id: this.matricula.aluno_id,
            turma_id: this.turmaSelecionada.id,
            serie_id: this.matricula.serie_id,
            situacao: this.matricula.situacao,
            sistema_bncc_id_turma: this.turmaSelecionada.sistema_bncc_id,
            sistema_bncc: this.matricula.sistema_bncc,
          },
          matricula: this.matricula,

          check: this.check,
        };

        this.$loaderService.open("Transferindo matrícula");
        const { matricula } = await this.$services.matriculasService.transferirMatricula(form);

        this.$loaderService.close();

        if (
          this.$constants.situacoesMatriculaParaDeclaracaoTransferencia.includes(
            form.matriculaTransferida.situacao
          ) ||
          this.$constants.situacoesMatriculaParaDeclaracaoTransferencia.includes(
            matricula?.situacao
          )
        ) {
          this.$modals.info({
            title: "Matrícula transferida!",
            message: "Deseja imprimir declaração de transferencia?",
            buttons: [
              {
                text: "Cancelar",
                callback: () => {
                  this.$modals.close();
                  this.$forceUpdate();
                  window.location.reload();
                },
                props: {
                  color: "warning",
                  small: true,
                },
              },
              {
                text: "Confirmar",
                callback: async () => {
                  this.$loaderService.open("Gerando declaração de transferência");
                  await this.$services.relatoriosService.declaracaoTransferencia(
                    this.matricula?.id
                  );
                  this.$modals.close();
                  this.$forceUpdate();
                  window.location.reload();
                  this.$loaderService.close();
                },
                props: {
                  color: "error",
                  // text: true,
                  small: true,
                },
              },
            ],
          });
        } else {
          window.location.reload();
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bncc-warning-modal {
  border-radius: 8px;
  overflow: hidden;

  .v-card__title {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .warning-content {
    .v-alert {
      border-left-width: 4px;
    }

    .consequences {
      background-color: #fafafa;
      border-radius: 4px;
      padding: 12px;

      .consequence-list {
        .v-icon {
          font-size: 8px;
        }
      }
    }

    .info-item {
      display: flex;
      align-items: center;
    }
  }

  .v-card__actions {
    border-top: 1px solid rgba(0, 0, 0, 0.1);

    .v-btn {
      min-width: 140px;
      text-transform: none;
      font-weight: 500;
    }
  }
}

// Melhorias de espaçamento e tipografia
.text-body-2 {
  line-height: 1.4;
}

.consequence-item {
  line-height: 1.3;
}

.confirmation-text {
  p {
    line-height: 1.5;
  }
}
</style>
